// Dropdown backdrop

export default (() => {
  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.navbar .dropdown-faded')
      .forEach(function (bgOverlay) {
        bgOverlay.addEventListener('shown.bs.dropdown', function () {
          var el_overlay = document.createElement('span')
          el_overlay.className = 'dropdown-backdrop'
          document.body.appendChild(el_overlay)
        })

        bgOverlay.addEventListener('hide.bs.dropdown', function () {
          document.body.removeChild(
            document.querySelector('.dropdown-backdrop')
          )
        })
      })
  })
})()
